import { requireEnv } from "@/lib/env";
import type { IpInfo } from "@/types/vendors/Ipregistry";

export class IpregistryClient {
  static readonly throwErrorIfExists = (response: Response, message: string) => {
    if (response.status >= 400 && response.status <= 599) {
      throw Error(message);
    }
  };

  static async lookupIp(): Promise<IpInfo> {
    const apiKey = requireEnv(process.env.NEXT_PUBLIC_GEO_LOCATION_API_KEY, "NEXT_PUBLIC_GEO_LOCATION_API_KEY");
    const response = await fetch(`https://api.ipregistry.co/?key=${apiKey}`, {
      method: "GET",
    });

    IpregistryClient.throwErrorIfExists(response, "Failed to get geolocation data from ipregistry.co");

    return await response.json();
  }
}
